import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history } from '../router';
import LoadingDots from './ui/LoadingDots';
import ReactPaginate from 'react-paginate';
import {
  FORM_STATUS,
  PAGINATION,
  REQUEST_TYPE,
  URL_PREFIX,
} from '../const/forms';
// import {ActionsDefaultState, ActionsRules} from '../const/action_rules';
import {
  copyForm,
  deleteForm,
  getForms,
  revokeForm,
  getHistory,
} from '../actions';
import { getProcessStatus } from './Utils';
import '../static/css/main.scss';

import HistoryStatusModal from './program/history/';
import { getFiletExtension } from '../modules/metajson-sub/src/libs/helpers/Utils';
import { ConfirmModal } from '../modules/metajson-sub/src/widgets/modals/confirm-modal';

// import LastComment from '../modules/metajson-sub/src/components/LastComment';

const LANGUAGE = {
  ru: 'Русский',
  en: 'Русский и Английский',
};

class RequestList extends Component {
  constructor() {
    super();
    this.onDelete = this.onDelete.bind(this);
    this.onCopy = this.onCopy.bind(this);
    // this.onRevoke = this.onRevoke.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.paginationClick = this.paginationClick.bind(this);
    this.modal = HistoryStatusModal;
    this.revokeModal = ConfirmModal;
    this.state = {
      currentPage: PAGINATION.page,
    };
    // this.lastComment = LastComment;
  }

  goForm(event, opts) {
    event.stopPropagation();
    event.preventDefault();
    const { form_type, process_id } = opts;
    history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
  }

  onDelete(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.deleteForm(form_type, process_id, this.state.currentPage);
  }

  onCopy(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.copyForm(form_type, process_id);
  }

  showHistory(e, request) {
    e.stopPropagation();
    e.preventDefault();

    this.modal.show(request);
  }

  onModalRevoke(e, form_type, process_id) {
    e.stopPropagation();
    e.preventDefault();

    this.revokeModal.show(form_type, process_id);
  }

  getRowAct(item) {
    return item.stage_title;
  }

  paginationClick(e) {
    this.props.getForms(e.selected + 1, PAGINATION.pagesize);
    this.setState({ currentPage: e.selected + 1 });
  }

  // onShowLastComment(event, form_type, process_id) {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   this.props.getHistory(process_id);
  //   this.lastComment.show();
  // }

  render() {
    const { forms, mode, loaders, pagination } = this.props;

    return (
      <LoadingDots
        show={typeof loaders['forms'] !== 'undefined' || !this.props.modeLoaded}
      >
        {forms.length > 0 && (
          <div className="table-responsive text-block">
            <table className="table table-bordered table-hover request-list">
              <thead>
                <tr>
                  <td>Номер</td>
                  <td>Компания</td>
                  <td>Дата подачи</td>
                  <td>Дата изменения</td>
                  <td>Документы</td>
                  <td>Статус</td>
                  <td>Действия</td>
                </tr>
              </thead>
              <tbody>
                {forms
                  .sort((a, b) => {
                    return a.process_id > b.process_id ? 1 : -1;
                  })
                  .map((item) => {
                    const files = [
                      ...(item.DocumentsExpertProtocol?.inputs ?? []),
                      ...(item.DocumentsInvoice?.inputs ?? []),
                    ];

                    return (
                      <tr
                        className="report-list-group"
                        key={item.item_id}
                        onClick={(event) =>
                          this.goForm(event, {
                            form_type: item.form_type,
                            process_id: item.process_id,
                          })
                        }
                      >
                        {/* ID */}
                        <td>{item.process_id || ''}</td>

                        {/* Компания - данные из поля Название компании */}
                        <td>{item.form_settings.company_name}</td>

                        {/* Дата подачи */}
                        <td>
                          {item.created_at
                            ? new Date(item.created_at).toLocaleString()
                            : ''}
                        </td>

                        {/* Дата изменения  */}
                        <td>
                          {item.updated_at
                            ? new Date(item.updated_at).toLocaleString()
                            : ''}
                        </td>

                        {/* Документы */}
                        <td style={{ padding: 0 }}>
                          {files &&
                            files.map((item) => (
                              <a
                                href={item.url}
                                onClick={(e) => e.stopPropagation()}
                                className="file-table-list"
                              >
                                <div
                                  className={`file-table-list__icon fileicon fileicon-${getFiletExtension(
                                    item.name,
                                  ).toLowerCase()}`}
                                />
                                <div className="file-table-list__name">
                                  <span>{item.name}</span>
                                </div>
                              </a>
                            ))}
                        </td>

                        {/* Статус - текущий статус заявки */}
                        <td className="request-list__status">
                          <div className="btn-group-vertical" role="group">
                            <button className={`btn btn-primary`}>
                              {getProcessStatus(item)}
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={(event) =>
                                this.showHistory(event, item.process_id)
                              }
                              title="История изменений"
                            >
                              История изменений
                            </button>
                          </div>
                        </td>

                        {/* Действия - доступные действия для заявки в текущем статусе (отозвать) */}
                        <td>
                          {/*! копирование пока что отключено, раскомментить, чтобы вернуть */}
                          {/* <button
                            title="Копировать"
                            className="btn btn-primary btn-xs"
                            onClick={(event) =>
                              this.onCopy(
                                event,
                                item.form_type,
                                item.process_id,
                              )
                            }
                          >
                            <span className="glyphicon glyphicon-duplicate" />
                          </button> */}
                          &nbsp;
                          <button
                            className="btn btn-danger btn-xs"
                            onClick={(event) =>
                              this.onDelete(
                                event,
                                item.form_type,
                                item.process_id,
                              )
                            }
                            title="Удалить"
                          >
                            <span className="glyphicon glyphicon-remove" />
                          </button>
                          &nbsp;
                          {FORM_STATUS[item.form_status] !== 'Черновик' && (
                            <button
                              className="btn btn-primary btn-xs"
                              onClick={(event) =>
                                this.onModalRevoke(
                                  event,
                                  item.form_type,
                                  item.process_id,
                                )
                              }
                              title="Отозвать"
                            >
                              <span className="glyphicon glyphicon-arrow-left" />
                            </button>
                          )}
                          {/*{item.form_status != 0 && <button className="btn btn-primary btn-xs" onClick={event => this.onRevoke(event, item.form_type, item.process_id)} title="Отозвать">*/}
                          {/*  <span className="glyphicon glyphicon-arrow-left" />*/}
                          {/*</button>}*/}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {pagination.total > pagination.pagesize ? (
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={this.paginationClick}
                pageRangeDisplayed={5}
                pageCount={Math.ceil(pagination.total / pagination.pagesize)}
                previousLabel="<"
                renderOnZeroPageCount={null}
                className="paginator"
              />
            ) : null}
            <HistoryStatusModal ref={(modal) => (this.modal = modal)} />
            <ConfirmModal
              ref={(modal) => (this.revokeModal = modal)}
              func={this.props.revokeForm}
            />
          </div>
        )}
        {forms.length === 0 && (
          <div className="text-block text-block_empty">
            Не найдено ни одной заявки
          </div>
        )}
        {/* <LastComment
          ref={(modal) => this.lastComment = modal}
          data={{
            history: this.props.history,
            userRole: this.props.userRole,
            loaders,
            extRules: {
              ActionsDefaultState,
              ActionsRules,
            }
          }}
        /> */}
      </LoadingDots>
    );
  }
}

RequestList.propTypes = {
  forms: PropTypes.array.isRequired,
  pagination: PropTypes.shape({}).isRequired,
  loaders: PropTypes.shape({}).isRequired,
  history: PropTypes.array,
  userRole: PropTypes.string,
};

const mapDispatchToProps = {
  copyForm,
  deleteForm,
  getForms,
  getHistory,
  revokeForm,
};

const mapStateToProps = (state) => ({
  mode: state.forms.mode,
  forms: state.forms.forms,
  loaders: state.forms.loaders,
  modeLoaded: state.forms.modeLoaded,
  pagination: state.forms.pagination,
  history: state.forms.history,
  userRole: state.forms.user.userRole,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
